import { useEffect } from 'react';

export default function Toast({ message, visible, onHide }) {
  useEffect(() => {
    if (!visible) return;
    const t = setTimeout(onHide, 3000);
    return () => clearTimeout(t);
  }, [visible, onHide]);

  if (!visible) return null;

  return (
    <div
      style={{
        position: 'fixed',
        bottom: 80,
        left: '50%',
        transform: 'translateX(-50%)',
        maxWidth: 360,
        width: 'calc(100% - 40px)',
        padding: '12px 20px',
        background: '#16a34a',
        color: 'white',
        fontSize: '0.875rem',
        fontWeight: 600,
        borderRadius: 'var(--radius-sm)',
        textAlign: 'center',
        zIndex: 250,
        animation: 'toastIn 0.25s ease',
        boxShadow: '0 4px 16px rgba(0,0,0,0.3)',
      }}
    >
      {message}
      <style>{`
        @keyframes toastIn {
          from { opacity: 0; transform: translateX(-50%) translateY(12px); }
          to { opacity: 1; transform: translateX(-50%) translateY(0); }
        }
      `}</style>
    </div>
  );
}
